import { cibGooglesCholar, cilSpeedometer, cilBank } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { CNavTitle, CNavItem } from '@coreui/react-pro';
import { SUBSCRIBER_PATH } from '../constants';

const subscriberNav = [
     {
          component: CNavItem,
          name: 'Dashboard',
          to: '/my-account',
          icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
     },
     {
          component: CNavItem,
          name: 'My Designations',
          to: SUBSCRIBER_PATH.MY_DESIGNATION,
          icon: <CIcon icon={cibGooglesCholar} customClassName="nav-icon" />,
     },
     {
          component: CNavTitle,
          name: 'MY LEARNING',
     },
     {
          component: CNavTitle,
          name: 'CERTIFICATES & CEs',
     },
     {
          component: CNavItem,
          name: 'CE Certificates',
          to: SUBSCRIBER_PATH.MY_CE_CERTIFICATES,
          icon: <CIcon icon={cilBank} customClassName="nav-icon" />,
     },
     {
          component: CNavItem,
          name: 'Certificates of Training',
          to: SUBSCRIBER_PATH.MY_CE_OF_COMPLETION,
          icon: <CIcon icon={cilBank} customClassName="nav-icon" />,
     },
     {
          component: CNavTitle,
          name: 'MY PROFESSIONAL DETAILS',
     },
     {
          component: CNavItem,
          name: 'My Professional',
          to: SUBSCRIBER_PATH.MY_PROFESSIONAL_DETAIL,
          icon: <CIcon icon={cilBank} customClassName="nav-icon" />,
     },
];

export default subscriberNav;
